import {axiosConfigNew as axios, axiosConfigOld} from "../../../utils/axios";

export const apiAuth = (body: any) => axios.post(`/users/auth`, body).then(({data}) => data);

export const apiGetUserProfile = () => axios.get(`/users/profile`)

export const apiGetMenu = () => axios.get(`/menu`)

export const apiGetNotification = () => axios.get(`/notification/unread`)

export const apiSetNotification = () => axios.get(`/notification/unread/read`)

//entrant
export const apiVerificationCode = (body:any) => axiosConfigOld.post("/new-entrant/send-confirmation-code", body);
export const apiRegistration = (body:any) => axiosConfigOld.post("/new-entrant/signup", body);